<script lang="ts" setup>
const i18n = useI18n()

const langs = [
  { label: 'JP', value: 'ja' },
  { label: 'EN', value: 'en' },
]
const changeStation = (langCode) => {
  i18n.setLocale(langCode)
}

const anchors = [
  { label: 'ホーム', href: '#home' },
  { label: '会社紹介', href: '#brief' },
  { label: '会社情報', href: '#introduce' },
  { label: '事業内容', href: '#service' },
  { label: 'ニュース', href: '#news' },
  { label: 'お問い合わせ', href: '#contact' },
]
</script>

<template>
  <ADevice>
    <template #h5>
      <ADrawer size="61.8%" class=" px-2 py-3" :mount="true">
        <template #trigger>
          <span class=" text-[1.5rem]">
            <svgo-menu></svgo-menu>
          </span>
        </template>
        <template #header>
          <div class=" flex-1 py-3 px-2">
            <img class=" h-6" src="https://static-jp.theckb.com/static-asset/xr/X&R.svg" alt="">
          </div>
        </template>
        <template #default="{ toggle }">
          <AAnchor path="/" class=" mt-8" @change="e => toggle(false)" :anchors="anchors" v-bind="$attrs">
            <template #default="{ item, active }">
              <MText placement="left" size="lg" class="px-2 py-3 rounded transition-colors"
                :class="active && ' bg-[#00000008] font-bold'">
                {{ item.label }}
              </MText>
            </template>
          </AAnchor>
        </template>
      </ADrawer>
    </template>
    <template #pc>
      <AAnchor path="/" class=" flex gap-[40px]" :anchors="anchors" v-bind="$attrs">
        <template #default="{ item, active }">
          <MText size="lg" :class="active && ' font-bold'">
            {{ item.label }}
          </MText>
        </template>
      </AAnchor>
    </template>
  </ADevice>
</template>

<style lang="scss" scoped></style>
